/**
 * Input Status Indicator Directive
 * Responsible for setting error status on a custom component
 *
 */
import {
  Directive,
  Host,
  Optional,
  HostBinding,
  ElementRef,
  Inject
} from '@angular/core';

import { InputGroupFieldComponent } from '../input-group/input-group-field.component';
import { FormRowComponent } from '../row/form-row.component';
import { FormComponent } from '../form.component';
import { BaseInputStatusDirective } from './base-input-status.directive';

@Directive({
  selector: '[tdWbInputStatusIndicator], [tdWbInput]:not(input)'
})
export class InputStatusIndicatorDirective extends BaseInputStatusDirective {
  @HostBinding('class.td-wb-error') showErrorClass: boolean;

  constructor(@Inject(ElementRef) elementRef: ElementRef,
              @Inject(InputGroupFieldComponent) @Host() @Optional() inputGroupField: InputGroupFieldComponent,
              @Inject(FormComponent) @Optional() form: FormComponent,
              @Inject(FormRowComponent) @Host() @Optional() formRow: FormRowComponent) {
    super(elementRef, inputGroupField, form, formRow);
  }

  protected onErrorStateChange(): void {
    super.onErrorStateChange();
    this.showErrorClass = this.isErrorState();
  }
}
